import axios from "axios";

export default () => {
  // HTTP GET Request - Returns Resolved or Rejected Promise
  const get = (path, data) => {
    return axios({
      method: "GET",
      url: path,
      params: data || {},
    });
  };

  // HTTP PATCH Request - Returns Resolved or Rejected Promise
  const patch = (path, data) => {
    return axios({
      method: "PATCH",
      url: path,
      data: data || {},
    });
  };

  // HTTP PATCH Request - Returns Resolved or Rejected Promise
  const put = (path, data) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: path,
        data: data || {},
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(errorHandler(error, deleteAuth));
        });
    });
  };

  // HTTP POST Request - Returns Resolved or Rejected Promise
  const post = (path, data) => {
    return axios({
      method: "POST",
      url: path,
      data: data || {},
    });
  };

  // HTTP DELETE Request - Returns Resolved or Rejected Promise
  const del = (path) => {
    return axios({
      method: "DELETE",
      url: path,
    });
  };

  return {
    get,
    patch,
    post,
    del,
    put,
  };
};
